import AbstractCommand from "../../../core/application/AbstractCommand";
import TeaCornerModel from "../model/TeaCornerModel";

export default class TeaCornerContentUnavailableCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {TeaCornerModel} teaCornerModel 
     */
    constructor(dispatcher, teaCornerModel) {
        super(dispatcher);

        this._teaCornerModel = teaCornerModel;
    }

    execute(evt) {
        const data = evt.params.data;

        const content = data.content;

        const teaCornerContent = this._teaCornerModel.getContentByInnerContent(content);
        this._teaCornerModel.removeContent(teaCornerContent);
    }
}